
var stache = require('can/view/stache/stache');
module.exports = stache("<tv-schedule {events}=\"events\" />\r\n");